export const primeiraLetraMaiuscula = (str) =>
  str.toLowerCase().replace(/(^|\s)\S/g, (palavra) => palavra.toUpperCase());
